"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeviceType = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
const useDeviceType = () => {
  const [isECatalogue, setIsECatalogue] = (0, _react.useState)(false);
  const mobileBreakpoint = (0, _mui.useMediaQuery)(theme => theme.breakpoints.down('sm'));
  const mobileBreakpointECatalogue = (0, _mui.useMediaQuery)(theme => theme.breakpoints.down('md'));
  (0, _react.useEffect)(() => {
    setIsECatalogue(document.getElementById('catalogue-ipaper-root') !== null);
  }, []);
  const isMobile = (0, _react.useMemo)(() => isECatalogue ? mobileBreakpointECatalogue : mobileBreakpoint, [isECatalogue, mobileBreakpointECatalogue, mobileBreakpoint]);
  return {
    isECatalogue,
    isMobile
  };
};
exports.useDeviceType = useDeviceType;
